import { Link, useParams } from "react-router-dom";
import { useI18n } from "@/i18n";
import { useMeta } from "@/lib/useMeta";
import { PublicPage } from "@/components/site";
import LEGAL from "@/pages/legalTexts";

export default function Legal() {
  const { doc } = useParams();
  const { t, lang } = useI18n();
  const key = LEGAL.tr[doc] ? doc : "privacy";
  const sections = LEGAL[lang][key];
  useMeta(`${t(`legal.${key}`)} | woodesing`, t(`meta.legal.${key}`), { page: key });
  return (
    <PublicPage testid="legal-page">
      <div className="max-w-3xl mx-auto px-5 py-12">
        <p className="inline-block text-xs px-2.5 py-1 rounded-full bg-amber-500/15 text-amber-300 mb-4" data-testid="legal-draft-badge">{t("common.draft")}</p>
        <h1 className="text-3xl sm:text-4xl font-semibold">{t(`legal.${key}`)}</h1>
        <div className="mt-10 space-y-8">
          {sections.map(([h, p]) => (
            <section key={h}>
              <h2 className="text-lg font-semibold">{h}</h2>
              <p className="text-neutral-400 mt-2 leading-relaxed">{p}</p>
            </section>
          ))}
        </div>
        <div className="mt-12 flex flex-wrap gap-4 text-sm">
          {["privacy", "terms", "cookies", "subscription"].map((d) => (
            <Link key={d} to={`/legal/${d}`} className="text-emerald-400 hover:underline">{t(`legal.${d}`)}</Link>
          ))}
        </div>
      </div>
    </PublicPage>
  );
}
